import { Box } from "@chakra-ui/react";
import Image from "next/image";
import Link from "next/link";
import { type FC } from "react";
import { toysubInviteUrl } from "@/configs/externalUrls";
import { inviteBannerTestId } from "./const";

export const InviteBanner: FC = () => {
  return (
    <Box
      as={Link}
      href={toysubInviteUrl}
      target="_blank"
      rel="noopener noreferrer"
      display="block"
      borderRadius="0.5rem"
      overflow="hidden"
      data-testid={inviteBannerTestId}
    >
      <Image
        src="/images/banner_invite_bonus_20261005.png"
        alt="紹介ボーナスキャンペーン トイサブ！を紹介でお友だちやご家族が2大特典GET 先着100名限定のデジタルギフト1,500円分 知育おもちゃサブスク初月3,980円分が1円"
        width={570}
        height={509}
        style={{ width: "100%", height: "auto" }}
      />
    </Box>
  );
};
